import React from 'react';
import { Rating } from '@bonprix/design-system';
import MessageBroker from '@bonprix/pattern-library/components/message-broker';
import ProductMessages from './message-list';
import Breakpoint from "@core/scripts/helper/breakpoint.js";

const ProductRating = ({ rating, ratingQuantity, fullWidth, ariaLabel}) => {
    const onClick = () => {
        const isDesktopView = Breakpoint.keyIsIn(['large', 'xlarge', 'max']);
        if (fullWidth && isDesktopView) {
            MessageBroker.publish(ProductMessages.OPEN_SIDE_SHEET_FOR_REVIEWS);
            return;
        }
        MessageBroker.publish(ProductMessages.SCROLL_TO_REVIEWS);
    };

    const ariaLabelText = `${ratingQuantity}${ariaLabel ? ' ' + ariaLabel : ''}`;

    return (
        // use of button for tab navigation a11y
        <button onClick={onClick} className="cursor-pointer" aria-label={ariaLabelText}>
            <Rating
                rating={rating}
                size="small"
            />
            <span> ({ratingQuantity}) </span>
        </button>
    );
};

export default ProductRating;
